import React from "react";
import { LoadingSpinnerProps } from "../types";

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Loading...",
  size = "md",
  color = "primary"
}) => {
  const sizeMap = {
    sm: 24,
    md: 48,
    lg: 64,
  };

  const colorMap = {
    primary: "#162F5C",
    sky: "#0ea5e9",
    blue: "#2563eb",
    green: "#10b981",
    gray: "#6b7280",
  };

  const dimension = sizeMap[size];
  const strokeColor = colorMap[color];

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <svg
        className="animate-spin mb-4"
        width={dimension}
        height={dimension}
        viewBox="0 0 50 50"
        aria-label="Loading"
        role="status"
      >
        <circle
          className="opacity-20"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={strokeColor}
          strokeWidth="5"
        />
        <circle
          className="opacity-100"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={strokeColor}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray="90, 150"
          strokeDashoffset="0"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="1s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>

      {message && (
        <p
          className={`font-heading font-semibold text-lg animate-pulse`}
          style={{ color: strokeColor }}
        >
          {message}
        </p>
      )}
    </div>
  );
}; 